import { render, staticRenderFns } from "./subscriptionsPage.vue?vue&type=template&id=8f7bf358&scoped=true"
import script from "./subscriptionsPage.vue?vue&type=script&lang=js"
export * from "./subscriptionsPage.vue?vue&type=script&lang=js"
import style0 from "./subscriptionsPage.vue?vue&type=style&index=0&id=8f7bf358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7bf358",
  null
  
)

export default component.exports